export default {
    Metadata: {
        Name: "GetVisibleRecordCount",
        Description: "Returns the number of records currently visible in the form with any client filtering applied.",
        Syntax: "GetVisibleRecordCount()",
        Keywords: ['Records', 'Page', 'Visible', 'Count'],
        Author: "DataVoke, Inc.",
        UpdatesOnData: true
    },
    execute() {
        let mvc = app.dv.helpers.exprEng.currexpression && app.dv.helpers.exprEng.currexpression.mvc;
        if (mvc != null && mvc.gridController != null) {
            // get the current number of records visible in the gridController.
            return mvc.gridController.boundArray.rows;
        }
        else {
            // unknown; return 0.
            return 0;
        }
    },
};

